import React from 'react';
import { Flex } from '../../flayr-components/Flex/Flex';

interface IProviderProfileSectionProps {
  icon?: React.ReactNode;
  className?: string;
}

const ProviderProfileSection: React.FC<React.PropsWithChildren<React.PropsWithChildren<IProviderProfileSectionProps>>> = ({
  icon,
  children,
  className,
}) => {
  return (
    <Flex y="start" className={className}>
      <div className="flex-none w-10 pt-1 lg:hidden">{icon}</div>
      <div className="flex-grow">{children}</div>
    </Flex>
  );
};
export default ProviderProfileSection;
